var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#6D28D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1506 25H34.8733C38.1027 25 40.3574 27.2254 40.3574 30.4146V39.5854C40.3574 42.7746 38.1027 45 34.8733 45H27.1506C23.9212 45 21.6665 42.7746 21.6665 39.5854V30.4146C21.6665 27.2254 23.9212 25 27.1506 25ZM45.6105 28.172C46.1958 27.8742 46.8825 27.9053 47.4412 28.2573C47.9998 28.6079 48.3332 29.217 48.3332 29.883V40.1178C48.3332 40.7852 47.9998 41.393 47.4412 41.7436C47.1358 41.9344 46.7945 42.0319 46.4505 42.0319C46.1638 42.0319 45.8771 41.9642 45.6091 41.8275L43.6345 40.8312C42.9038 40.4603 42.4504 39.7158 42.4504 38.8887V31.1107C42.4504 30.2823 42.9038 29.5378 43.6345 29.1696L45.6105 28.172Z",
    fill: "#6D28D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/videoicon.ae00715e58f867c58481a83e47d6e8f4.svg";
export { ForwardRef as ReactComponent };